import { tv } from 'tailwind-variants';

import baseStyles from './Base.styles';

const styles = tv({
  extend: baseStyles,
  slots: {
    base: `
      flex
      select-none
      items-center
      space-x-2
    `,
  },
});

export default styles;
